import Toast from './toast';
import {MAP_ZOOM} from '@/config/map';
import {updateReadAtForManagerNotification} from '@/firebase/notification';
import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import {setAirportDetail} from '@/redux/slice/airportSlice';
import {
  StatusTrackerTab,
  setNotificationToggle,
  setStatusTrackerTab,
  setStatusTrackerToggle,
  setTMMChatToggle
} from '@/redux/slice/appSlice';
import {setFlightDetail} from '@/redux/slice/flightSlice';
import {
  IToast,
  ToastActionType,
  hideToast,
  removeToast
} from '@/redux/slice/toastSlice';
import {toast as toastify} from 'react-toastify';

const AppToastContainer = () => {
  const dispatch = useAppDispatch();
  const {toasts} = useAppSelector((state) => state.toast);
  const {flightData, flightDataReady} = useAppSelector((state) => state.flight);
  const {airportData, airportDataReady} = useAppSelector(
    (state) => state.airport
  );
  const {statusTrackerToggle, statusTrackerTab} = useAppSelector(
    (state) => state.app
  );

  const getAction = (toast: IToast) => {
    switch (toast?.actionType) {
      case ToastActionType.CHAT: {
        const event = new CustomEvent('chatDetail', {
          detail: {
            id: toast?.entity?.id
          }
        });
        window.chatDetail.dispatchEvent(event);
        break;
      }
      case ToastActionType.FLIGHT: {
        if (!flightDataReady) {
          if (statusTrackerTab !== StatusTrackerTab.FLIGHT)
            dispatch(setStatusTrackerTab(StatusTrackerTab.FLIGHT));
          if (!statusTrackerToggle) dispatch(setStatusTrackerToggle(true));
          toastify.info('Flight data is loading, please try again later');
          return;
        }
        const flight = flightData?.find(
          (item) => item.id === toast?.entity?.id
        );
        if (flight) {
          if (statusTrackerTab !== StatusTrackerTab.FLIGHT)
            dispatch(setStatusTrackerTab(StatusTrackerTab.FLIGHT));
          if (!statusTrackerToggle) dispatch(setStatusTrackerToggle(true));
          dispatch(setFlightDetail(flight));
        }
        break;
      }
      case ToastActionType.AIRPORT: {
        window.updateData({
          event: 'camera',
          data: {
            center: [toast?.entity?.long, toast?.entity?.lat],
            zoom: MAP_ZOOM
          }
        });
        if (!airportDataReady) {
          if (statusTrackerTab !== StatusTrackerTab.AIRPORT)
            dispatch(setStatusTrackerTab(StatusTrackerTab.AIRPORT));
          if (!statusTrackerToggle) dispatch(setStatusTrackerToggle(true));
          toastify.info('Airport data is loading, please try again later');
          return;
        }
        const airport = airportData?.find(
          (item) => item.airport === toast?.entity?.airport
        );
        if (airport) {
          if (statusTrackerTab !== StatusTrackerTab.AIRPORT)
            dispatch(setStatusTrackerTab(StatusTrackerTab.AIRPORT));
          if (!statusTrackerToggle) dispatch(setNotificationToggle(true));
          dispatch(setAirportDetail(airport));
        }
        break;
      }
      case ToastActionType.OPS:
      case ToastActionType.ETL: {
        dispatch(setTMMChatToggle(true));
        const event = new CustomEvent('tmmChatDetail', {
          detail: toast?.thread || ''
        });
        window.tmmChatDetail.dispatchEvent(event);
        break;
      }
      default:
        console.log('No action type found');
        break;
    }
    const airline = localStorage.getItem('airline') ?? '';
    updateReadAtForManagerNotification(airline, toast?.firebaseKey);
    onRemoveToast(toast);
  };

  const onRemoveToast = (toast: IToast) => {
    dispatch(hideToast(toast.id));
    setTimeout(() => {
      dispatch(removeToast(toast.id));
    }, 1000);
  };

  const onDismiss = (toast: IToast) => {
    // window.skipListenNotification = true;
    // setTimeout(() => {
    //   window.skipListenNotification = false;
    // }, 3000);
    const airline = localStorage.getItem('airline') ?? '';
    updateReadAtForManagerNotification(airline, toast?.firebaseKey);
    onRemoveToast(toast);
  };

  return (
    <div className="fixed top-[56px] left-[68px] flex flex-col">
      {toasts?.map((toast) => (
        <Toast
          key={toast.id}
          title={toast.title}
          message={toast.message}
          actionType={toast.actionType}
          actionText={toast.actionText}
          onPress={() => getAction(toast)}
          onClose={() => onRemoveToast(toast)}
          onDismiss={() => onDismiss(toast)}
          visible={toast.visible}
          entity={toast.entity}
        />
      ))}
    </div>
  );
};

export default AppToastContainer;
